import { styled } from "@mui/system";

export const PrivacyContainer = styled("div")({
  textAlign: "center",
  width: "100%",
  position: "absolute",
  bottom: "10px",
});
